(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(74887);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ SeverityPill; },
/* harmony export */   "T": function() { return /* binding */ StateChip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_formatters__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56238);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81719);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);





const StateChip = (props)=>{
    const { state , state_name , ...other } = props;
    let pillColor = (0,_utils_formatters__WEBPACK_IMPORTED_MODULE_2__/* .stateToColor */ .TE)(state);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SeverityPill, {
        color: pillColor,
        ...other,
        children: state_name
    });
};
const SeverityPillRoot = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("span")((param)=>{
    let { theme , ownerState  } = param;
    const backgroundColor = theme.palette[ownerState.color].alpha12;
    const color = theme.palette.mode === "dark" ? theme.palette[ownerState.color].main : theme.palette[ownerState.color].dark;
    return {
        alignItems: "center",
        backgroundColor,
        borderRadius: 12,
        color,
        cursor: "default",
        display: "inline-flex",
        flexGrow: 0,
        flexShrink: 0,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(12),
        lineHeight: 2,
        fontWeight: 600,
        justifyContent: "center",
        letterSpacing: 0.5,
        minWidth: 20,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        textTransform: "uppercase",
        whiteSpace: "nowrap"
    };
});
const SeverityPill = (props)=>{
    const { color ="primary" , children , ...other } = props;
    const ownerState = {
        color
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SeverityPillRoot, {
        ownerState: ownerState,
        ...other,
        children: children
    });
};
SeverityPill.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    color: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf([
        "primary",
        "secondary",
        "error",
        "info",
        "warning",
        "success"
    ])
};


/***/ }),

/***/ 74887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js
var Box = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Container/Container.js
var Container = __webpack_require__(78016);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Unstable_Grid2/Grid2.js
var Grid2 = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/layouts/index.tsx + 24 modules
var layouts = __webpack_require__(95760);
// EXTERNAL MODULE: ./src/hooks/use-settings.ts
var use_settings = __webpack_require__(71711);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForward.js
var ArrowForward = __webpack_require__(93619);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardActions/CardActions.js + 1 modules
var CardActions = __webpack_require__(62026);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 2 modules
var Button = __webpack_require__(75084);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(28223);
// EXTERNAL MODULE: ./src/components/NavLink.tsx
var NavLink = __webpack_require__(90206);
;// CONCATENATED MODULE: ./src/components/overview/overview-stat.tsx





const OverviewStats = (props)=>{
    const { amount , icon , title , link  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-around",
                direction: {
                    xs: "column",
                    sm: "row"
                },
                spacing: 3,
                sx: {
                    px: 4,
                    py: 3
                },
                children: [
                    icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexGrow: 1
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "text.primary",
                            variant: "h5",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: "primary",
                        variant: "h4",
                        children: amount
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.C, {
                    href: link,
                    color: "inherit",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {})
                        }),
                        size: "small",
                        children: [
                            "Voir toutes les ",
                            title.toLowerCase()
                        ]
                    })
                })
            })
        ]
    });
};
OverviewStats.propTypes = {
    amount: (prop_types_default()).number.isRequired
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Person.js
var Person = __webpack_require__(15398);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(94690);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/School.js
var School = __webpack_require__(88698);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Groups.js
var Groups = __webpack_require__(27547);
// EXTERNAL MODULE: ./src/api/index.tsx + 2 modules
var api = __webpack_require__(36357);
;// CONCATENATED MODULE: ./src/api/stats.ts

const addTagTypes = [
    "stats"
];
const injectedRtkApi = api/* mystesApi.enhanceEndpoints */.k.enhanceEndpoints({
    addTagTypes
}).injectEndpoints({
    endpoints: (build)=>({
            statsRetrieve: build.query({
                query: ()=>({
                        url: "/api/v1/stats/"
                    }),
                providesTags: [
                    "stats"
                ]
            })
        }),
    overrideExisting: false
});

const { useStatsRetrieveQuery , useLazyStatsRetrieveQuery  } = injectedRtkApi;

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(59742);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(41796);
;// CONCATENATED MODULE: ./src/components/chart.tsx


const ApexChart = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(279), __webpack_require__.e(229)]).then(__webpack_require__.bind(__webpack_require__, 47229)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(47229)
            ]
    },
    ssr: false,
    loading: ()=>null
});
const Chart = (0,styled/* default */.ZP)(ApexChart)((param)=>{
    let { theme  } = param;
    return {
        "& .apexcharts-xaxistooltip": {
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[16],
            borderRadius: theme.shape.borderRadius,
            border: 0,
            "&::before, &::after": {
                display: "none"
            }
        },
        "& .apexcharts-tooltip": {
            "&.apexcharts-theme-light, &.apexcharts-theme-dark": {
                backdropFilter: "blur(6px)",
                background: "transparent",
                border: 0,
                boxShadow: "none",
                "& .apexcharts-tooltip-title": {
                    background: (0,colorManipulator/* alpha */.Fq)(theme.palette.neutral[900], 0.8),
                    border: 0,
                    color: theme.palette.common.white,
                    margin: 0
                },
                "& .apexcharts-tooltip-series-group": {
                    background: (0,colorManipulator/* alpha */.Fq)(theme.palette.neutral[900], 0.7),
                    border: 0,
                    color: theme.palette.common.white
                }
            }
        }
    };
});

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
;// CONCATENATED MODULE: ./src/components/overview/overview-application-count.tsx






const OverviewApplicationCount = (props)=>{
    const theme = (0,useTheme/* default */.Z)();
    var _data_yearly_applications;
    const { stats  } = useStatsRetrieveQuery(undefined, {
        selectFromResult: (param)=>{
            let { data  } = param;
            return {
                stats: (_data_yearly_applications = data === null || data === void 0 ? void 0 : data.yearly_applications) !== null && _data_yearly_applications !== void 0 ? _data_yearly_applications : {
                    series: [],
                    axis: []
                }
            };
        }
    });
    const chartOptions = (0,react.useMemo)(()=>({
            chart: {
                background: "transparent",
                stacked: false,
                toolbar: {
                    show: false
                }
            },
            colors: [
                theme.palette.primary.main,
                theme.palette.mode === "dark" ? theme.palette.primary.darkest : theme.palette.primary.light
            ],
            dataLabels: {
                enabled: true
            },
            legend: {
                labels: {
                    colors: theme.palette.text.secondary
                },
                onItemClick: {
                    toggleDataSeries: false
                },
                onItemHover: {
                    highlightDataSeries: false
                }
            },
            grid: {
                borderColor: theme.palette.divider,
                strokeDashArray: 2
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    columnWidth: "32px"
                }
            },
            theme: {
                mode: theme.palette.mode
            },
            tooltip: {
                y: {
                    formatter: (value)=>"".concat(value, " candidatures")
                }
            },
            xaxis: {
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                categories: stats.axis,
                labels: {
                    style: {
                        colors: theme.palette.text.secondary
                    }
                }
            },
            yaxis: {
                labels: {
                    show: true
                }
            }
        }), [
        stats.axis,
        theme.palette.divider,
        theme.palette.mode,
        theme.palette.primary.darkest,
        theme.palette.primary.light,
        theme.palette.primary.main,
        theme.palette.text.secondary
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                title: "Candidatures par formation",
                subheader: "Sur les 2 derni\xe8res ann\xe9es"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    height: 336
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart, {
                    height: 300,
                    options: chartOptions,
                    series: stats.series,
                    type: "bar"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Table/Table.js + 1 modules
var Table = __webpack_require__(90244);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(93978);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TableCell/TableCell.js
var TableCell = __webpack_require__(7272);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(39807);
// EXTERNAL MODULE: ./node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(52602);
// EXTERNAL MODULE: ./src/components/state-chip.tsx
var state_chip = __webpack_require__(30579);
// EXTERNAL MODULE: ./src/utils/formatters.ts
var formatters = __webpack_require__(56238);
;// CONCATENATED MODULE: ./src/components/overview/overview-last-applications.tsx










const OverviewLastApplications = (props)=>{
    var _data_last_applications;
    const { stats  } = useStatsRetrieveQuery(undefined, {
        selectFromResult: (param)=>{
            let { data  } = param;
            return {
                stats: (_data_last_applications = data === null || data === void 0 ? void 0 : data.last_applications) !== null && _data_last_applications !== void 0 ? _data_last_applications : []
            };
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                title: "Derni\xe8res candidatures",
                subheader: "Ordre d\xe9croissant"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    children: "Candidat"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    children: "Promotion"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    children: "Date"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    children: "\xc9tat"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                        children: stats.map((element)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                sx: {
                                    "&:last-child td, &:last-child th": {
                                        border: 0
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            py: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.C, {
                                            href: {
                                                pathname: paths/* paths.applications.detail */.H.applications.detail,
                                                query: {
                                                    id: element.candidate_id
                                                }
                                            },
                                            color: "text.primary",
                                            variant: "subtitle2",
                                            children: element.candidate
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "center",
                                        sx: {
                                            py: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.C, {
                                            href: {
                                                pathname: paths/* paths.sessions.detail */.H.sessions.detail,
                                                query: {
                                                    id: element.session_id
                                                }
                                            },
                                            color: "text.primary",
                                            variant: "subtitle2",
                                            children: element.session
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "center",
                                        sx: {
                                            py: 1
                                        },
                                        children: luxon/* DateTime.fromISO */.ou.fromISO(element.received_date).toLocaleString(luxon/* DateTime.DATE_FULL */.ou.DATE_FULL)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "center",
                                        sx: {
                                            py: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(state_chip/* StateChip */.T, {
                                            state: element.state,
                                            state_name: (0,formatters/* stateToLabel */.kl)(element.state)
                                        })
                                    })
                                ]
                            }, element.candidate_id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.C, {
                    href: paths/* paths.sessions.index */.H.sessions.index,
                    color: "inherit",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "inherit",
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {})
                        }),
                        size: "small",
                        children: "D\xe9tails"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/overview/overview-open-sessions.tsx






const OverviewOpenSessions = (props)=>{
    var _data_open_applications;
    const { stats  } = useStatsRetrieveQuery(undefined, {
        selectFromResult: (param)=>{
            let { data  } = param;
            return {
                stats: (_data_open_applications = data === null || data === void 0 ? void 0 : data.open_applications) !== null && _data_open_applications !== void 0 ? _data_open_applications : []
            };
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                title: "Inscriptions ouvertes",
                subheader: "Par promotion"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                size: "small",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    children: "Promotion"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    children: "Ann\xe9e"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    children: "Candidatures"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                        children: stats.map((param)=>{
                            let { session , count  } = param;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                sx: {
                                    "&:last-child td, &:last-child th": {
                                        border: 0
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            py: 0.5
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.C, {
                                            href: {
                                                pathname: paths/* paths.sessions.detail */.H.sessions.detail,
                                                query: {
                                                    id: session.id
                                                }
                                            },
                                            color: "text.primary",
                                            variant: "subtitle2",
                                            children: session.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "center",
                                        sx: {
                                            py: 0.5
                                        },
                                        children: session.year
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "center",
                                        sx: {
                                            py: 0.5
                                        },
                                        children: count
                                    })
                                ]
                            }, session.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavLink/* default */.C, {
                    href: paths/* paths.sessions.index */.H.sessions.index,
                    color: "inherit",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "inherit",
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {})
                        }),
                        size: "small",
                        children: "D\xe9tails"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/overview/overview-application-types.tsx






const OverviewApplicationTypes = (props)=>{
    const theme = (0,useTheme/* default */.Z)();
    var _data_applications_types;
    const { stats  } = useStatsRetrieveQuery(undefined, {
        selectFromResult: (param)=>{
            let { data  } = param;
            return {
                stats: (_data_applications_types = data === null || data === void 0 ? void 0 : data.applications_types) !== null && _data_applications_types !== void 0 ? _data_applications_types : {
                    series: [],
                    axis: []
                }
            };
        }
    });
    const chartOptions = (0,react.useMemo)(()=>({
            chart: {
                background: "transparent",
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            colors: [
                theme.palette.warning.main,
                theme.palette.info.main,
                theme.palette.success.main,
                theme.palette.error.main,
                theme.palette.common.black
            ],
            dataLabels: {
                enabled: true
            },
            legend: {
                labels: {
                    colors: theme.palette.text.secondary
                },
                onItemClick: {
                    toggleDataSeries: false
                },
                onItemHover: {
                    highlightDataSeries: false
                }
            },
            grid: {
                borderColor: theme.palette.divider,
                strokeDashArray: 2
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    columnWidth: "32px"
                }
            },
            theme: {
                mode: theme.palette.mode
            },
            tooltip: {
                y: {
                    formatter: (value)=>"".concat(value, " candidatures")
                }
            },
            xaxis: {
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                },
                categories: stats.axis,
                labels: {
                    style: {
                        colors: theme.palette.text.secondary
                    }
                }
            },
            yaxis: {
                labels: {
                    show: true
                }
            }
        }), [
        stats.axis,
        theme.palette.divider,
        theme.palette.mode,
        theme.palette.primary.darkest,
        theme.palette.primary.light,
        theme.palette.primary.main,
        theme.palette.text.secondary
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                title: "\xc9tat des candidatures",
                subheader: "Par promotion ouvertes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    height: 336
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart, {
                    height: 300,
                    options: chartOptions,
                    series: stats.series,
                    type: "bar"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/index.tsx
















const Home = ()=>{
    const settings = (0,use_settings/* useSettings */.r)();
    var _data_model_count;
    const { stats  } = useStatsRetrieveQuery(undefined, {
        selectFromResult: (param)=>{
            let { data  } = param;
            return {
                stats: (_data_model_count = data === null || data === void 0 ? void 0 : data.model_count) !== null && _data_model_count !== void 0 ? _data_model_count : {
                    application: 0,
                    session: 0,
                    major: 0
                }
            };
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Mystes - Tableau de bord"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "main",
                sx: {
                    flexGrow: 1,
                    py: 2
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: settings.stretch ? false : "xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid2/* default */.Z, {
                        container: true,
                        disableEqualOverflow: true,
                        spacing: {
                            xs: 3,
                            lg: 4
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h4",
                                    children: "Tableau de bord"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                xs: 12,
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewStats, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Person/* default */.Z, {
                                        fontSize: "large"
                                    }),
                                    amount: stats.application,
                                    title: "Candidatures",
                                    link: paths/* paths.applications.index */.H.applications.index
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                xs: 12,
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewStats, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Groups/* default */.Z, {
                                        fontSize: "large"
                                    }),
                                    amount: stats.session,
                                    title: "Promotions",
                                    link: paths/* paths.sessions.index */.H.sessions.index
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                xs: 12,
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewStats, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(School/* default */.Z, {
                                        fontSize: "large"
                                    }),
                                    amount: stats.major,
                                    title: "Formations",
                                    link: paths/* paths.majors.index */.H.majors.index
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid2/* default */.Z, {
                                container: true,
                                xs: 12,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewApplicationCount, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                        xs: 12,
                                        md: 6,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewApplicationTypes, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                container: true,
                                xs: 12,
                                md: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewLastApplications, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                container: true,
                                xs: 12,
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid2/* default */.Z, {
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverviewOpenSessions, {})
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
Home.getLayout = (page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* Layout */.A, {
        children: page
    });
Home.auth = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 56238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A9": function() { return /* binding */ WhyApplyToLabel; },
/* harmony export */   "Er": function() { return /* binding */ WHY_APPLY_LABELS; },
/* harmony export */   "R8": function() { return /* binding */ EGE_KNOWN_LABELS; },
/* harmony export */   "TE": function() { return /* binding */ stateToColor; },
/* harmony export */   "VD": function() { return /* binding */ EgeKnownToLabel; },
/* harmony export */   "W0": function() { return /* binding */ MAJOR_FORM_TYPE; },
/* harmony export */   "ck": function() { return /* binding */ getApplicationStates; },
/* harmony export */   "kl": function() { return /* binding */ stateToLabel; }
/* harmony export */ });
const stateToColor = (state)=>{
    switch(state){
        case 0:
            return "warning";
        case 1:
            return "info";
        case 2:
            return "success";
        case 3:
            return "error";
        case 4:
            return "error";
    }
    return "primary";
};
const stateToLabel = (state)=>{
    switch(state){
        case 0:
            return "Candidature re\xe7ue";
        case 1:
            return "Candidature valid\xe9e";
        case 2:
            return "Candidat inscrit";
        case 3:
            return "Candidat refus\xe9";
        case 4:
            return "Abandon";
    }
};
const getApplicationStates = ()=>{
    let states = [
        0,
        1,
        2,
        3,
        4
    ];
    return states.map((state)=>{
        return {
            value: state,
            name: stateToLabel(state),
            color: stateToColor(state)
        };
    });
};
const WhyApplyToLabel = (value)=>{
    switch(value){
        case 0:
            return "Autre";
        case 1:
            return "Le r\xe9seau et d\xe9bouch\xe9s";
        case 2:
            return "La connaissance produite par l'EGE / AEGE";
        case 3:
            return "La notori\xe9t\xe9 et le classement de l'\xc9cole";
        case 4:
            return "Une recommandation";
        case 5:
            return "La possibilit\xe9 d'alternance";
        case 6:
            return "Le programme";
    }
};
const EgeKnownToLabel = (state)=>{
    switch(state){
        case 0:
            return "Autre";
        case 1:
            return "Une recommandation d'un professionnel";
        case 2:
            return "Une recommandation d'un enseignant";
        case 3:
            return "Une recherche sur Internet (Google...)";
        case 4:
            return "Un salon \xe9tudiant ou professionnel";
        case 5:
            return "Une porte ouverte EGE";
        case 6:
            return "Par le portail de l'IE";
        case 7:
            return "Un article ou \xe9tude, ouvrage produit par l'\xc9cole";
        case 8:
            return "Un article de presse portant sur l'\xc9cole";
        case 9:
            return "Une publicit\xe9 digitale ( Linkedin, Facebook)";
        case 10:
            return "Un \xe9v\xe9nement EGE / AEGE (Conf\xe9rences, Carr\xe9, Gala...)";
        case 11:
            return "Les r\xe9seaux sociaux de l'\xc9cole ou du r\xe9seau (Linkedin, Facebook, X, Instagram, Youtube)";
        case 12:
            return "Une recommandation d'un \xe9tudiant ou d'un alumni";
    }
};
const EGE_KNOWN_LABELS = [
    "Autre",
    "Une recommandation d'un professionnel",
    "Une recommandation d'un enseignant",
    "Une recherche sur Internet (Google...)",
    "Un salon \xe9tudiant ou professionnel",
    "Une porte ouverte EGE",
    "Par le portail de l'IE",
    "Un article ou \xe9tude, ouvrage produit par l'\xc9cole",
    "Un article de presse portant sur l'\xc9cole",
    "Une publicit\xe9 digitale ( Linkedin, Facebook)",
    "Un \xe9v\xe9nement EGE / AEGE (Conf\xe9rences, Carr\xe9, Gala...)",
    "Les r\xe9seaux sociaux de l'\xc9cole ou du r\xe9seau (Linkedin, Facebook, X, Instagram, Youtube)",
    "Une recommandation d'un \xe9tudiant ou d'un alumni"
];
const WHY_APPLY_LABELS = [
    "Autre",
    "Le r\xe9seau et d\xe9bouch\xe9s",
    "La connaissance produite par l'EGE / AEGE",
    "La notori\xe9t\xe9 et le classement de l'\xc9cole",
    "Une recommandation",
    "La possibilit\xe9 d'alternance",
    "Le programme"
];
const MAJOR_FORM_TYPE = [
    "Initial",
    "Executive"
];


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [293,505,985,765,760,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);